import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../components/table/Table';
import Tag from '../../../components/tag/Tag';
import styles from './ProgramClinicalSitesTable.module.scss';
import { getSpecialityTagVariant } from '../../../utils/specialityUtils';

const ProgramClinicalSitesTable = ({ clinicalSites = [], isSelectable = false, onRowSelect, selectedRows }) => {
    
    const columns = [
        {
            header: 'Clinical Site',
            key: 'name',
            render: (row) => row.name
        },
        {
            header: 'Specialty',
            key: 'specialty',
            render: (row) => (
                <div className={styles.specialtyList}>
                    {row.specialities?.map((spec, index) => (
                        <Tag 
                            key={spec.id} 
                            text={spec.name}
                            variant={getSpecialityTagVariant(spec.name)}
                            rounded={true}
                        />
                    ))}
                </div>
            )
        },
        {
            header: 'Year',
            key: 'year',
            render: (row) => (
                <div className={styles.yearList}>
                    {row.supportedYears?.map(y => (
                        <span key={y.id}>{y.year}</span>
                    ))}
                </div>
            )
        }
    ];

    return (
        <Table 
            columns={columns}
            data={clinicalSites}
            onRowSelect={isSelectable ? onRowSelect : undefined}
            selectedRows={isSelectable ? selectedRows : undefined}
        />
    );
};

ProgramClinicalSitesTable.propTypes = {
  clinicalSites: PropTypes.array,
  isSelectable: PropTypes.bool,
  onRowSelect: PropTypes.func,
  selectedRows: PropTypes.array
};

export default ProgramClinicalSitesTable;
